import React, { useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSun, faMoon } from "@fortawesome/free-solid-svg-icons";
import { ThemeContext } from "../../context/ThemeContext";

const ThemeSwitcher = () => {
  const { theme, toggleTheme } = useContext(ThemeContext);

  return (
    <button
      onClick={toggleTheme}
      className="theme-switcher"
      title={`Switch to ${theme === "light" ? "dark" : "light"} theme`}
    >
      <FontAwesomeIcon
        icon={theme === "light" ? faMoon : faSun}
        className="theme-icon"
      />
    </button>
  );
};

export default ThemeSwitcher;
